/** Small browser preferences only. Business records and permissions remain in the database. */
export const cookieStorage = {
    getItem(key: string): string | null {
        if (typeof document === 'undefined') return null;
        const name = `${encodeURIComponent(key)}=`;
        const cookie = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(name));
        if (!cookie) return null;
        try { return decodeURIComponent(cookie.slice(name.length)); } catch { return null; }
    },
    setItem(key: string, value: string): void {
        const encoded = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        if (encoded.length > 3800) throw new Error('Este dato debe guardarse en el servidor, no en una cookie de preferencias.');
        document.cookie = `${encoded}; Max-Age=31536000; Path=/; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;
        window.dispatchEvent(new Event('cookie-preferences-changed'));
    },
    removeItem(key: string): void {
        document.cookie = `${encodeURIComponent(key)}=; Max-Age=0; Path=/; SameSite=Lax`;
        window.dispatchEvent(new Event('cookie-preferences-changed'));
    },
};
